import React, { forwardRef } from 'react';
import InputTemplate from '../TemplateNumberFormatInput'

const CpfInput = forwardRef((props, ref) => (
    <InputTemplate {...props} formato="###.###.###-##" ref={ref} />
));

export default CpfInput